<template>
  <Modal
    :title="!payrunType._id ? 'Add Payrun Process' : 'Edit Payrun Process'"
    :show-modal="title === 'Payrun Type'"
    @close="$emit('close')"
  >
    <div class="p-4">
      <section class="mb-4">
        <p class="w-full text-sm text-gray-400 min-w-max">Company</p>
        <select
          class="w-full border focus:outline focus:outline-primary px-3 py-1.5 bg-white rounded-md text-sm"
          v-model="formPayrunType.company"
        >
          <option :value="null" selected disabled>Selcted company</option>
          <option
            v-for="(company, i) in companies"
            :key="i"
            class="px-2 py-1"
            :value="company._id"
          >
            {{ company.company_name }}
          </option>
        </select>
      </section>
      <div class="mb-4">
        <p class="w-full text-sm text-gray-400 min-w-max">Name</p>
        <input
          type="text"
          class="w-full text-sm border outline-gray-600 focus:outline focus:outline-primary pr-4 py-1.5 bg-white rounded pl-4"
          v-model="formPayrunType.name"
        />
      </div>
      <div>
        <label for="description" class="w-full text-sm text-gray-400 min-w-max"
          >Description</label
        >
        <textarea
          name="description"
          id=""
          cols="30"
          rows="10"
          class="w-full text-sm border outline-gray-600 focus:outline focus:outline-primary pr-4 py-1.5 bg-white rounded pl-4"
          v-model="formPayrunType.description"
        ></textarea>
      </div>
      <section class="mb-4">
        <p class="w-full text-sm text-gray-400 min-w-max">Color Value</p>
        <select
          class="w-full border focus:outline focus:outline-primary px-3 py-1.5 bg-white rounded-md text-sm"
          v-model="formPayrunType.color"
        >
          <option :value="null" selected disabled>Selected color</option>
          <option
            v-for="(color, i) in colors"
            :key="i"
            class="px-2 py-1"
            :value="color.value"
          >
            {{ color.text }}
          </option>
        </select>
      </section>

      <section class="mt-4">
        <p class="w-full text-sm text-gray-400 min-w-max">Output File</p>
        <select
          class="w-full border focus:outline focus:outline-primary px-3 py-1.5 bg-white rounded-md text-sm"
          v-model="formPayrunType.selectedFile"
        >
          <option :value="null" selected disabled>Selcted output file</option>
          <option
            v-for="(outputFile, i) in outputFiles"
            :key="i"
            class="px-2 py-1"
            :value="outputFile._id"
          >
            {{ `${outputFile.description} (${outputFile.type_file})` }}
          </option>
        </select>
      </section>
    </div>
    <template v-slot:footer>
      <section class="flex flex-row justify-end gap-x-2 w-52">
        <Button
          class="w-24 py-2 text-white rounded-md bg-primary"
          @click="savePayrunType"
        >
          Save
        </Button>
        <Button
          class="w-24 py-2 text-white bg-gray-400 rounded-md"
          @click="$emit('close')"
        >
          Close
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Button from "@/components/Button.vue";

export default {
  name: "ModalPayrunType",
  components: {
    Modal,
    Button,
  },
  props: {
    payrunType: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    companies: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
    outputFiles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formPayrunType: {
        id: null,
        name: "",
        description: "",
        selectedFile: null,
        company: null,
        color: null,
      },
    };
  },
  watch: {
    payrunType: {
      handler(value) {
        this.formPayrunType = {
          id: value._id || null,
          color: value.color,
          description: value.description,
          selectedFile: value.output_file ? value.output_file._id : null,
          name: value.payrun_type,
          company: value.company_id,
        };
      },
      immediate: true,
    },
  },
  methods: {
    savePayrunType() {
      if (this.formPayrunType.id === null) {
        this.$emit("on-submit-payrun-type", this.formPayrunType);
      } else {
        this.$emit("on-update-payrun-type", this.formPayrunType);
      }
    },
  },
};
</script>
